import { observer } from 'mobx-react';
import PreviousOrdersList from '../PreviousOrdersList/PreviousOrdersList';
import { useCheckoutStoreContext } from '../../context';
import Menu from './Menu/Menu';

const CheckoutProductsTab: React.FC = observer((): JSX.Element => {
  const { store: checkoutStore } = useCheckoutStoreContext();
  return (
    <div className="d-flex flex-1 flex-column pt-4">
      <Menu branch={checkoutStore.dependencies.branch} time={checkoutStore.params.preorder_date} />
      {checkoutStore.dependencies.customer && checkoutStore.isDraft ? <PreviousOrdersList /> : null}
    </div>
  );
});

export default CheckoutProductsTab;
